import { InvoiceExportTypeId } from '@previo/codebooks'
import { DefaultCountryStrategy } from '~/pages/setting/applications/accounting/exports/software/i10n/countries/DefaultCountryStrategy'

export class CZECountryStrategy extends DefaultCountryStrategy {
  public allowedSoftware: InvoiceExportTypeId[] = [
    InvoiceExportTypeId.ISDOC,
    InvoiceExportTypeId.POHODA,
    InvoiceExportTypeId.MONEY_S3,
  ]
}
